import { SxProps, Theme } from "@mui/material/styles";
import { gridClasses } from "@mui/x-data-grid";

/**
 * Common DataGrid styles for consistent appearance across the application
 */
export const commonDataGridStyles: SxProps<Theme> = {
  boxShadow: 0,
  border: 0,
  borderColor: "primary.light",
  backgroundColor: "transparent",
  "& .MuiDataGrid-main": {
    backgroundColor: "transparent",
  },
  "& .MuiDataGrid-cell": {
    backgroundColor: "transparent",
  },
  "& .MuiDataGrid-row": {
    backgroundColor: "transparent",
  },
  "& .MuiDataGrid-cell:hover": {
    color: "primary.main",
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: "none",
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
    {
      outline: "none",
    },
};

/**
 * DataGrid styles with additional customizations
 */
export const enhancedDataGridStyles: SxProps<Theme> = {
  ...commonDataGridStyles,
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "background.paper",
    fontWeight: "bold",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "action.hover",
  },
};

/**
 * Compact DataGrid styles for smaller screens or dense layouts
 */
export const compactDataGridStyles: SxProps<Theme> = {
  ...commonDataGridStyles,
  "& .MuiDataGrid-cell": {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "4px 8px",
    fontSize: "0.875rem",
  },
};

/**
 * Default DataGrid props for consistent behavior
 */
export const defaultDataGridProps = {
  slots: { toolbar: undefined }, // Can be overridden
  slotProps: {
    toolbar: {
      showQuickFilter: true,
      quickFilterProps: { debounceMs: 500 },
    },
    loadingOverlay: {
      variant: "linear-progress" as const,
      noRowsVariant: "linear-progress" as const,
    },
  },
  pageSizeOptions: [10, 25, 50, 100],
  checkboxSelection: false,
  initialState: {
    pagination: {
      paginationModel: { page: 0, pageSize: 100 },
    },
  },
};

/**
 * DataGrid props specifically for purchases/orders grids
 */
export const purchasesDataGridProps = {
  ...defaultDataGridProps,
  initialState: {
    pagination: {
      paginationModel: { page: 0, pageSize: 100 },
    },
  },
};
